import { render, staticRenderFns } from "./RightPanelOverlay.vue?vue&type=template&id=64bfa4cb&scoped=true&"
import script from "./RightPanelOverlay.vue?vue&type=script&lang=js&"
export * from "./RightPanelOverlay.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelOverlay.vue?vue&type=style&index=0&id=64bfa4cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfa4cb",
  null
  
)

export default component.exports